<template>
  <b-modal
    title="میانگین نمره استاد بر اساس سوال"
    id="question-rate-modal"
    centered
    ok-title="بستن"
    ok-variant="success"
    ok-only
  >
    <b-overlay :show="isLoading">
      <b-container fluid>
        <b-form-row v-if="surveyQuestionDetails">
          <b-col cols="12">
            <p>
              سوال انتخاب شده:
              <span style="font-weight: bold">
                {{ surveyQuestionDetails.questionTitle }}
              </span>
            </p>
            <p>
              تعداد شرکت کنندگان:
              <span style="font-weight: bold">
                {{ surveyQuestionDetails.count }}
              </span>
              نفر
            </p>
            <p>
              میانگین نمره‌ی کاربران در این پاسخ:
              <span style="font-weight: bold">
                {{ surveyQuestionDetails.average }}%
              </span>
            </p>
          </b-col>
        </b-form-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  props: {
    questionId: {
      type: [String, Number],
    },
    surveyId: {
      type: [String, Number],
    },
  },
  watch: {
    questionId: {
      handler(val) {
        if (val) {
          this.getQuestionDetails();
        }
      },
    },
  },
  data() {
    return {
      isLoading: false,
      surveyQuestionDetails: null,
    };
  },
  methods: {
    async getQuestionDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getReportsOfMasterByQuestionId = new GetReportsOfMasterByQuestionId(
          _this
        );
        getReportsOfMasterByQuestionId.setRequestParam({
          surveyId: _this.surveyId,
          masterId: _this.$route.params.masterId,
          questionId: _this.questionId,
        });
        await getReportsOfMasterByQuestionId.fetch((res) => {
          _this.surveyQuestionDetails = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BModal,
    BOverlay,
    BContainer,
    BRow,
    BCol,
    BTable,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
};
import {
  BModal,
  BOverlay,
  BContainer,
  BRow,
  BCol,
  BTable,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import { GetReportsOfMasterByQuestionId } from "@/libs/Api/SuveyUserSurvey";
</script>
